import {React} from "react";
import styled  from "styled-components";

// images
import imgharmonyAvond from '../img/harmonyavond.jpeg'
import imgPrint from '../img/harmonyprint.jpg'
import raumvideo from '../img/raumvideo.mp4'


const IpCarContainer = styled.div`

    position: relative;
    padding-top: 100px;
    width: 100%;
    height: 100%;
    color: white;
    z-index: 1;

    iframe{
      width: 50vw;
      height: calc(50vw/1.77);
    }
   
    h1{
      padding-top: 50px;
      margin:0;
      margin-left:20%;
      text-align: left;
    }
    p{
      text-align: left;
      width: 60%;
      margin-left:20%;
      
    }

  @media only screen and (max-width: 500px) {

      iframe{
        width: 90vw;
        height: calc(90vw/1.77);
       }
    
       h1{
        margin-left:10%; 
      }

      p{
        text-align: left;
        width: 80%;
        margin-left:10%;  
      }
}
`
const ImgContainer = styled.div`
padding-top: 50px;
width: 90%;
height:100%;
margin-left:5%;


`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin:3%;


  img{
    display: block;
    margin: auto;
    width: 50%;
  }

  video{
    padding-top: 10px;
    margin: auto;
    width: 60%;
  height: auto;
  }
`

function Raum() {


  return (
    <IpCarContainer>
      <iframe 
              src="https://www.youtube.com/embed/lagTkNAHCf0?modestbranding=0&autohide=1&showinfo=1&controls=0&autoplay=1"
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen>
            </iframe>
            <h1>Harmony</h1>
            <p>Voor de tentoonstelling ‘Living apart together’ heeft Circus Family de interactieve LED installatie Harmony ontwikkeld. 
              Met als doel bezoekers te verwonderen en dichter tot elkaar te brengen. 
              Deze installatie heeft van 30 november 2020 t/m 2 april 2021 in Utrecht gestaan.

            </p>
            <p>Voor deze installatie heb ik een online omgeving ontwikkeld die verbonden was in real time met de fysieke installatie. 
              Via een web app kon in realtime de installatie worden aangestuurd met touch bewegingen. Dit was op de livestream direct zichtbaar.
              Andersom als er iemand fysiek tussen de installatie doorliep was dat online ook direct zichtbaar. 
            </p>

            <p>Ervaringen: Nodejs, Vue, WebSocket, WebRTC, Threejs, Nginx</p>

            <ImgContainer>
              <Row>
            
                  <img src={imgharmonyAvond} alt="Snow"  style={{width: "40%"}}/>
           
                  <img src={imgPrint} alt="Snow" style={{width: "40%"}} />
                 
          
                
              </Row>
              <Row>
           
               
            
              <video muted autoPlay loop playsInline>
                  <source src={raumvideo} type="video/mp4" />Your browser does not support the video tag. I suggest you upgrade your browser.
              </video>
             
                
              </Row>
            </ImgContainer>
    </IpCarContainer>
  );
}
export default Raum;